import { render } from "./AddLdapAccount.vue?vue&type=template&id=4b8f4b16&scoped=true"
import script from "./AddLdapAccount.vue?vue&type=script&lang=js"
export * from "./AddLdapAccount.vue?vue&type=script&lang=js"

import "./AddLdapAccount.vue?vue&type=style&index=0&id=4b8f4b16&lang=less&scoped=true"

import exportComponent from "/opt/novus-cloud-ui/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b8f4b16"]])

export default __exports__